import { RoutePermittedRole } from "shared/constants/AppConst";
import Nodel from "./nodel_page";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const nodelMasterConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/nodelMessage",
    element: isModuleAuthorized("Nodel Message") ? <Nodel /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/nodelMessage",
    element: isModuleAuthorized("Nodel Message") ? <Nodel /> : <Error403 />,
  },
];
